import naja from 'naja';
import MicroModal from 'micromodal';

export default class AvatarUpload {
    static init(): void {
        this.initFilePreview();
        this.initSnippetListener();
        this.initFormSubmission();
    }

    private static initFilePreview(): void {
        const avatarInput = document.getElementById('avatar') as HTMLInputElement;
        const previewContainer = document.getElementById('avatar-preview') as HTMLElement;
        const previewImg = document.getElementById('avatar-preview-img') as HTMLImageElement;

        if (!avatarInput || !previewContainer || !previewImg) {
            return;
        }

        avatarInput.addEventListener('change', (event) => {
            const input = event.target as HTMLInputElement;
            const file = input.files?.[0];

            if (file && file.type.startsWith('image/')) {
                const reader = new FileReader();
                
                reader.onload = (e) => {
                    previewImg.src = e.target?.result as string;
                    previewContainer.style.display = 'block';
                    
                    // Hide current avatar or placeholder when preview is shown
                    const currentAvatar = document.querySelector('.avatar-upload-section__current') as HTMLElement;
                    const placeholder = document.querySelector('.avatar-upload-section__placeholder') as HTMLElement;
                    if (currentAvatar) currentAvatar.style.display = 'none';
                    if (placeholder) placeholder.style.display = 'none';
                };
                
                reader.readAsDataURL(file);
            } else {
                previewContainer.style.display = 'none';
                
                // Show current avatar or placeholder when preview is hidden
                const currentAvatar = document.querySelector('.avatar-upload-section__current') as HTMLElement;
                const placeholder = document.querySelector('.avatar-upload-section__placeholder') as HTMLElement;
                if (currentAvatar) currentAvatar.style.display = 'block';
                if (placeholder) placeholder.style.display = 'flex';
            }
        });
    }

    private static initSnippetListener(): void {
        naja.snippetHandler.addEventListener('afterUpdate', (event: { detail: { snippet: { id: string } } }) => {
            if (event.detail.snippet.id === 'snippet-personMenuSnippet') {
                // Reinitialize after snippet redraw
                this.initFilePreview();
            }
        });
    }

    private static initFormSubmission(): void {
        // Close modal on successful form submission
        naja.addEventListener('success', (event: any) => {
            // Check if the form was the avatar upload form
            const form = event.detail.form;
            if (form && form.classList.contains('avatar-upload-form')) {
                // Close the modal
                MicroModal.close('avatar-upload-modal');
                
                // Reset the form
                form.reset();
                
                // Hide preview
                const previewContainer = document.getElementById('avatar-preview');
                if (previewContainer) {
                    previewContainer.style.display = 'none';
                }
            }
        });
    }
}